var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"desc"},[_vm._v("抱歉，你访问的页面不存在")]),_c('router-link',{attrs:{"to":{path:'/login'}}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回首页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }